import {Injectable} from '@angular/core';

import {AuthorizeResponse, User} from '../../models/user';
import {Observable} from 'rxjs/Observable';

import {apiEndpoints} from '../app.constants';
import {BackendHttpService} from '../core/backend-http.service';

@Injectable()
export class AuthorizeService extends BackendHttpService<AuthorizeResponse> {

  public authorizeUser(username: string, password: string): Observable<AuthorizeResponse> {
    const params = JSON.stringify({username, password});
    return this.post(apiEndpoints.login, params);
  }

  public getTokenOfChannel(channelId: number, token: string): Observable<any> {
    return this.get(apiEndpoints.getToken, {
      channelId: channelId,
      token: token
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/authorize.service.ts